import useSEO, { SEO_CONFIG } from '@/hooks/useSEO';

export default function Privacy() {
  useSEO(SEO_CONFIG.privacy);
  
  return (
    <div className="py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-heading text-primary mb-12">Politique de confidentialité</h1>
        
        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Collecte des données personnelles</h2>
            <p>
              Conformément au RGPD, nous collectons uniquement les données nécessaires au traitement de vos demandes (contact, devis, location de tireuse) et à la gestion de notre relation commerciale.
            </p>
            <p>
              <strong>Données collectées :</strong>
            </p>
            <ul>
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone</li>
              <li>Contenu de votre message ou demande</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Utilisation des données</h2>
            <p>Vos données personnelles sont utilisées pour :</p>
            <ul>
              <li>Répondre à vos demandes de contact et de devis</li>
              <li>Traiter vos demandes de location de tireuse</li>
              <li>Gérer notre relation commerciale</li>
              <li>Améliorer nos services</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Conservation des données</h2>
            <p>
              Vos données sont conservées pendant la durée nécessaire à la gestion de la relation commerciale et conformément aux obligations légales.
            </p>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Vos droits</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul>
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité</li>
              <li>Droit d'opposition</li>
            </ul>
            <p>
              Pour exercer vos droits, contactez-nous à : <a href="mailto:soifdeprovence@gmail.com" className="text-accent underline">soifdeprovence@gmail.com</a><br />
              Ou par courrier :<br />
              Denis BONNELY<br />
              1688 petite route des Jardins<br />
              13210 Saint-Rémy-de-Provence
            </p>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Cookies</h2>
            <p>
              Nous utilisons uniquement des cookies techniques nécessaires au fonctionnement du site (session, mesure d'audience). Ces cookies ne nécessitent pas de consentement préalable.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}